import React, { useEffect } from "react";
import MainContainer from "../../components/container/MainContainer";
import Table from "../../components/tables/Table";
import { useDispatch, useSelector } from "react-redux";
import { getDonors } from "../../features/donorsSlice";
import Modal from "../../components/modal/Modal";
import Loading from "../../components/loading/Loading";
import { openModal } from "../../features/modalSLice";
import AddDonor from "./AddDonor";
import LocationHeader from "../../components/header/LocationHeader";
import { useAuthorization } from "../../hooks/useAuthorization";
import { useLocation } from "react-router-dom";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";

const Donor = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const donors = useSelector((state) => state.donors.data);
  const loading = useSelector((state) => state.donors.load.getDonors);
  const modalContent = useSelector((state) => state.modal.content);
  const { isAuthorized } = useAuthorization();

  const columns = [
    { id: "num", text: "Num" },
    { id: "name", text: "Name" },
    { id: "email", text: "Email" },
    { id: "country", text: "Country" },
    // { id: "action", text: "Actions" },
  ];

  const openAddDonorModa = () => {
    dispatch(openModal(<AddDonor />));
  };

  useEffect(() => {
    dispatch(getDonors());
    // return () => {
    //   dispatch(unsetDonors());
    // };
  }, []);

  if (loading === loadStatus.loading) {
    return <Loading />;
  }

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <>
      <Modal>{modalContent}</Modal>
      <MainContainer className={`text-text-1`}>
        <LocationHeader
          title="Donors"
          action={openAddDonorModa}
          authorized={isAuthorized("donors", "create")}
          links={[]}
        />
        <main className="table-container">
          {donors.length > 0 && (
            <Table
              columns={columns}
              data={donors}
              link
              // button={
              //   isAuthorized("donors", "update") ? openEditDonorModa : false
              // }
            />
          )}
          {donors.length <= 0 && (
            <div className="w-full h-full flex justify-center items-center">
              <h4 className="text-text-1/60">No Donors Added yet... </h4>
            </div>
          )}
        </main>
      </MainContainer>
    </>
  );
};

export default Donor;
